import classNames from 'classnames';
import { IconProps } from '.';

export const DashedCircleIcon = ({ color = '#969696', className }: IconProps) => {
  return (
    <svg
      className={classNames(className)}
      width='90'
      height='90'
      viewBox='0 0 90 90'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='45' cy='45' r='42' stroke={color} strokeWidth='6' strokeMiterlimit='3.8637' strokeDasharray='3 6' />
    </svg>
  );
};
